module.exports = __webpack_public_path__ + "img/get_code.763d729e.png";